import DevicesIcon from '@mui/icons-material/Devices';
import { UserDeviceTokenList } from './UserDeviceTokenList';

export default {
  list: UserDeviceTokenList,
  icon: DevicesIcon,
};
